import '@fancyapps/fancybox'
import '../styles/page-product.scss'